import { makeStyles } from '@mui/styles';
import { SHAMROCK } from '@returnmates/client-core/src/constants/colors';
var useStyles = makeStyles(function () { return ({
    main: {
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    root: {
        position: 'relative',
    },
    spinner: {
        color: SHAMROCK,
    },
    bigSpinner: {
        position: 'absolute',
        left: 0,
        top: 0,
        color: SHAMROCK,
        animation: '$circle 1s linear infinite',
    },
    bottom: {
        color: 'rgba(75, 209, 160, .2)',
    },
    circle: {
        strokeLinecap: 'round',
    },
    spinnerWrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        background: '#FFFFFF',
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
    },
    logo: {
        width: 180,
        marginBottom: 12,
    },
    '@keyframes circle': {
        '0%': {
            transform: 'rotate(0deg) rotate(180deg)',
        },
        '100%': {
            transform: 'rotate(360deg) rotate(180deg)',
        },
    },
}); });
export default useStyles;
//# sourceMappingURL=styles.js.map